module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [(!_vm.formData.user.length) ? _c('van-cell', {
    attrs: {
      "title": "用户选择",
      "is-link": "",
      "value": "请选择用户"
    },
    on: {
      "click": function($event) {
        _vm.showUserPicker = true
      }
    }
  }) : _c('van-cell', {
    attrs: {
      "title": "用户选择",
      "is-link": "",
      "value": "请选择用户"
    },
    on: {
      "click": function($event) {
        _vm.showUserPicker = true
      }
    }
  }, [_c('template', {
    slot: "default"
  }, [_c('span', {
    staticClass: "selected"
  }, [_vm._v(_vm._s(_vm.formData.user[0].name))])])], 2), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "用户类型",
      "is-link": "",
      "value": "请选择用户类型"
    },
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }, [_c('template', {
    slot: "default"
  }, [_c('span', {
    staticClass: "selected"
  }, [_vm._v(_vm._s(_vm.formData.typeName))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [(!_vm.saveLoading) ? _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "round": "",
      "size": "normal"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存\n    ")]) : _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "round": "",
      "size": "normal"
    }
  }, [_vm._v("保存中...\n    ")])], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.typeColumns
    },
    on: {
      "cancel": function($event) {
        _vm.showPicker = false
      },
      "confirm": _vm.onConfirm
    }
  })], 1), _vm._v(" "), _c('UserPicker', {
    attrs: {
      "show": _vm.showUserPicker,
      "limit": 1,
      "defaultValue": _vm.formData.user
    },
    on: {
      "onChange": _vm.onUserChange,
      "onClose": function($event) {
        _vm.showUserPicker = false
      },
      "onConfirm": _vm.onUserConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a227b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/QcxjDetailCommunityAdd.vue
// module id = 2442
// module chunks = 0